import { render } from "./FilterMain.vue?vue&type=template&id=0fdc6d8c&scoped=true"
import script from "./FilterMain.vue?vue&type=script&lang=js"
export * from "./FilterMain.vue?vue&type=script&lang=js"

import "./FilterMain.vue?vue&type=style&index=0&id=0fdc6d8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fdc6d8c"]])

export default __exports__